import { GET_OWN_OEM_SUPPORT_TICKETS_BY_TYPES_QUERY } from "#/src/api";
import { useAuth } from "#/src/components/general";
import { useLazyQuery } from "@apollo/client";
import type { TicketTypeType } from "@shared/types/oem";

export const useGetSupportTicketTypes = ({
  includeSystem = false,
}: { includeSystem?: boolean } = {}): TicketTypeType[] | undefined => {
  const { user } = useAuth();

  return user?.oem?.supportTicketTypes?.filter(
    (type: TicketTypeType) => includeSystem || !type?.isSystem,
  );
};

export const useCheckSupportTicketHasType = () => {
  const [checkTickets, { loading, error }] = useLazyQuery(
    GET_OWN_OEM_SUPPORT_TICKETS_BY_TYPES_QUERY,
  );
  return {
    loading,
    error,
    checkIfWorkOrderTypeUsed: async (typeId: string): Promise<boolean> => {
      const {
        data: { checkIfSupportTicketsExistForType } = {},
        error: checkError,
      } = await checkTickets({
        variables: { typeId },
      });

      // Treat a failed check as "in use": the caller deletes outright when this
      // returns false, so guessing wrong here would drop a type that still has
      // tickets attached to it.
      if (checkError) return true;

      return !!checkIfSupportTicketsExistForType;
    },
  };
};
